import React, { useMemo, useState } from 'react';

import { ISpecOfferChannel } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { pluralize } from '@r1-frontend/shared/helpers/pluralize';
import { channelPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import ChannelListPopup from '~/src/components/Bundles/ChannelListPopup';

import * as ST from './styled';

interface IOfferChannelsProps {
    channels?: ISpecOfferChannel[],
}

export const OfferChannels = ({ channels }: IOfferChannelsProps) => {
    const [isChannelsOpen, setIsChannelsOpen] = useState(false);
    const length = channels?.length || 0;

    const offerChannelIds = useMemo(
        () => channels ? (channels).map(({ id }) => id).flat() : [],
        [channels],
    );

    const link = useMemo(
        () => `${length} ${pluralize(length, channelPluralize)}`,
        [length],
    );

    if (!length) {
        return null;
    }

    return (
        <>
            <ST.ChannelsWrapper>
                <H4>В пакет входит</H4>
                <ST.ChannelsLink onClick={() => setIsChannelsOpen(true)}>
                    {link}
                </ST.ChannelsLink>
            </ST.ChannelsWrapper>

            <ChannelListPopup
                isOfferChannels={true}
                freePackets={offerChannelIds}
                isOpen={isChannelsOpen}
                onClose={() => setIsChannelsOpen(false)}
            />
        </>
    );
};
